export default {
  zh: {
    plexVpn: "Plex加速器",
    pcTitle: ["与世界无限接触 ", " 跨越国界加速"],
    bannerDes:
      "使用 Plex加速器作为您保护网络安全的盾牌！</br>为您的所有设备提供全面的互联网安全保障。",
    phoneTitle: "与世界无限接触</br>跨越国界加速",
    signUp: "获取 PlexVPN",
    registerAwards: "注册免费试用3天 ",
  },
  en: {
    plexVpn: "PlexVPN",
    pcTitle: ["Enjoy Unrestricted Access ", " Worldwide"],
    bannerDes:
      "With one tap, secure your online traffic with military-grade encryption. Perfect for streaming, gaming, and keeping your browsing private.",
    phoneTitle: "Enjoy Unrestricted Access Worldwide",
    signUp: "Get PlexVPN",
    registerAwards: "Enjoy 3 days free trial after register",
  },
};



// WEBPACK FOOTER //
// ./src/views/home/homeBanner/lang.js